import React, { useState, useEffect } from "react";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Navbar,
} from "reactstrap";

// core components
import NavItems from "./NavItems"

function WhiteNavbar() {
  const [bodyClick, setBodyClick] = useState(false);
  const [collapseOpen, setCollapseOpen] = useState(false);
  useEffect(() => {

    // See documentation here: https://wicky.nillia.ms/headroom.js/
    // TOOK ME FOREVER TO FIND IT
    const options = {
      classes: {
        unpinned: "headroom--unpinned"
      }
    }

    let headroom = new Headroom(document.getElementById("navbar-main"), options);
    // initialise
    headroom.init();
  });
  return (
    <>
      {bodyClick ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setBodyClick(false);
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className="fixed-top" expand="lg" id="navbar-main">
        <NavItems
          collapseOpen={collapseOpen}
          setBodyClick={setBodyClick}
          setCollapseOpen={setCollapseOpen}
        />
      </Navbar>
    </>
  );
}

export default WhiteNavbar;
